import * as i0 from '@angular/core';
import { InjectionToken, Component, Inject, Input, ViewChild, Directive, HostBinding, NgModule } from '@angular/core';
import 'jquery-tagcanvas/tagcanvas';
import { CommonModule } from '@angular/common';

const NATIVE_TAGCANVAS = new InjectionToken('The vanilla JavaScript TagCanvas object');

function generateRandomId() {
    return Math.random().toString(36).slice(2, 10);
}
class TagCanvasComponent {
    constructor(nativeTagCanvas) {
        this.nativeTagCanvas = nativeTagCanvas;
        this._instanceId = generateRandomId();
        this.canvasId = `canvas-${this._instanceId}`;
        this.tagListId = `tags-${this._instanceId}`;
        this.resizeObserver = new ResizeObserver(([entry]) => {
            const { width, height } = entry.contentRect;
            this.canvasElement.width = width;
            this.canvasElement.height = height;
        });
        this.mutationObserver = new MutationObserver(() => {
            this.nativeTagCanvas.Update(this.canvasId);
        });
    }
    get canvasElement() {
        return this.canvas.nativeElement;
    }
    get tagContainerElement() {
        return this.tagContainer.nativeElement;
    }
    ngAfterViewInit() {
        this.resizeObserver.observe(this.canvasElement);
        this.mutationObserver.observe(this.tagContainerElement, { childList: true });
        this.nativeTagCanvas.Start(this.canvasId, this.tagListId, Object.assign({ weightFrom: 'data-weight' }, this.options));
    }
    setSpeed(speed) {
        this.nativeTagCanvas.SetSpeed(this.canvasId, speed);
    }
    ngOnDestroy() {
        this.nativeTagCanvas.Delete(this.canvasId);
        this.resizeObserver.disconnect();
        this.mutationObserver.disconnect();
    }
}
TagCanvasComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TagCanvasComponent, deps: [{ token: NATIVE_TAGCANVAS }], target: i0.ɵɵFactoryTarget.Component });
TagCanvasComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TagCanvasComponent, selector: "ng-tag-canvas", inputs: { options: "options" }, viewQueries: [{ propertyName: "canvas", first: true, predicate: ["canvas"], descendants: true, static: true }, { propertyName: "tagContainer", first: true, predicate: ["tagContainer"], descendants: true, static: true }], ngImport: i0, template: `
    <canvas #canvas [attr.id]="canvasId"></canvas>
    <div #tagContainer [attr.id]="tagListId" class="tag-container">
      <ng-content></ng-content>
    </div>
  `, isInline: true, styles: ["\n      :host {\n        display: block;\n      }\n      \n      canvas {\n        display: block;\n        width: 100%;\n        height: 100%;\n      }\n      \n      .tag-container {\n        visibility: hidden;\n      }    \n    "] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TagCanvasComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ng-tag-canvas',
                    styles: [
                        `
      :host {
        display: block;
      }
      
      canvas {
        display: block;
        width: 100%;
        height: 100%;
      }
      
      .tag-container {
        visibility: hidden;
      }    
    `
                    ],
                    template: `
    <canvas #canvas [attr.id]="canvasId"></canvas>
    <div #tagContainer [attr.id]="tagListId" class="tag-container">
      <ng-content></ng-content>
    </div>
  `
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NATIVE_TAGCANVAS]
                }] }]; }, propDecorators: { options: [{
                type: Input
            }], canvas: [{
                type: ViewChild,
                args: ['canvas', { static: true }]
            }], tagContainer: [{
                type: ViewChild,
                args: ['tagContainer', { static: true }]
            }] } });

class TagDirective {
}
TagDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TagDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
TagDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TagDirective, selector: "a[ngTag]", inputs: { weight: "weight" }, host: { attributes: { "href": "javascript:void(0)" }, properties: { "attr.data-weight": "this.weight" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TagDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'a[ngTag]',
                    host: {
                        'href': 'javascript:void(0)'
                    }
                }]
        }], propDecorators: { weight: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.data-weight']
            }] } });

class TagCanvasModule {
    static forRoot(config) {
        // @ts-ignore
        const nativeTagCanvas = window['TagCanvas'];
        Object.assign(nativeTagCanvas, config || {});
        return {
            ngModule: TagCanvasModule,
            providers: [
                { provide: NATIVE_TAGCANVAS, useValue: nativeTagCanvas }
            ]
        };
    }
}
TagCanvasModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TagCanvasModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TagCanvasModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TagCanvasModule, declarations: [TagCanvasComponent, TagDirective], imports: [CommonModule], exports: [TagCanvasComponent, TagDirective] });
TagCanvasModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TagCanvasModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TagCanvasModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TagCanvasComponent, TagDirective],
                    imports: [CommonModule],
                    exports: [TagCanvasComponent, TagDirective],
                }]
        }] });

/*
 * Public API Surface of ng-tagcanvas
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TagCanvasComponent, TagCanvasModule, TagDirective };
